import { useQuery } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { MandateApplicationView } from "../types/Mandate";
import { env } from "../utils/env";
import { useNavigate } from "react-router-dom";
import { ROUTE } from "../routes";

const fetch = (authHeader: string, mandateId: number) => () =>
  axios.get<MandateApplicationView>(
    `${env.verifyServiceUrl}individual/mandate/${mandateId}/`,
    {
      headers: {
        Authorization: authHeader,
      },
    }
  );

export const useMandate = (mandateId: number) => {
  const { authHeader } = useAuth();
  const navigate = useNavigate();
  return useQuery(["mandate", mandateId], fetch(authHeader, mandateId), { enabled: Number.isInteger(mandateId), retry: false,
    onError: (err: any) => {
      if(err.request.status === 500 || err.request.status === 503) {
        navigate(ROUTE.SERVER_ERROR);
      }
      if(err.request.status === 404) {
        navigate(ROUTE.NOT_FOUND);
      }
    }
  });
};
